import { render, staticRenderFns } from "./ckjl.vue?vue&type=template&id=5e511d3e&scoped=true&"
import script from "./ckjl.vue?vue&type=script&lang=js&"
export * from "./ckjl.vue?vue&type=script&lang=js&"
import style0 from "./ckjl.vue?vue&type=style&index=0&id=5e511d3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e511d3e",
  null
  
)

export default component.exports